<!--
 * @Author: wangyinhu wangyinhude@163.com
 * @Date: 2024-01-05 11:17:34
 * @LastEditors: wangyinhu wangyinhude@163.com
 * @LastEditTime: 2025-04-23 13:48:47
 * @FilePath: \汇学堂Saas-企业中心pc\hxt-saas-pc\src\views\index2.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="index-container">
        <Header></Header>
        <div class="tabList-box">
            <div class="tabList">

                <div v-if="item.show" :class="active == item.id ? 'active' : ''" v-for="item in tab " :key="item.id"
                    @click="setTab(item)">
                    {{ item.name }}
                </div>
            </div>
        </div>

        <div class="content">
            <!-- 学习报告-->
            <StudyReport v-if="active == 'xxbg'" :modeVal="activeSlider"></StudyReport>
            <!--团队管理  -->
            <TeamManage v-if="active == 'tdgl'"></TeamManage>
            <!-- 学习计划 -->
            <StudyPlan v-if="active == 'xxjh'"></StudyPlan>
            <!-- 会员答疑 -->
            <Questing v-if="active == 'hydy'"></Questing>
            <!-- 课程管理 -->
            <CourseManage v-if="active == 'kcgl'"></CourseManage>
            <!-- 知识库 -->
            <zsk v-if="active == 'zsk'"> </zsk>
            <!-- 学习 -->
            <home v-if="active == 'home'"></home>

            <!-- 米诺测评 -->
            <mncp v-if="active == 'mncp'"></mncp>

        </div>
    </div>
</template>

<script>
import { switchCompanyChange, getAllCompany, userCompanyInfo, userLogout, getCompanyDetail, justifyAdmin, examStatus } from '@/api/index.js';

import Header from '@/components/Header.vue'
import Slider from '@/components/Slider.vue'
import TreeModel from '@/components/TreeModel.vue'
import EnterpriseCenter from './EnterCenter/index.vue'
import StudyReport from './StudyReport/index.vue'
import TeamManage from './TeamManage/index.vue'
import CourseManage from './CourseManage/index.vue'
import home from '@/views/xx.vue';
import StudyPlan from "@/views/StudyPlan/Index.vue";
import Questing from "@/views/Questing/index.vue";
import zsk from '@/components/zsk.vue';
import mncp from '@/components/mncp.vue';
import checkLoginRecord from '../utils/loginTime';
export default {
    name: '',
    components: {
        Header, Questing,
        Slider,
        TreeModel,
        EnterpriseCenter,
        StudyReport,
        TeamManage,
        CourseManage
        , StudyPlan, zsk, home, mncp
    },
    data() {
        return {
            courseStatus: "course-list",
            tab: [
                { name: '学习', id: "home", show: true, },
                { name: '知识库', id: "zsk", show: true, },
                { name: '米诺测评', id: "mncp", show: false, },
                { name: '学习计划', id: "xxjh", show: true, },
                { name: '会员答疑', id: "hydy", show: true, },
                { name: '学习报告', id: "xxbg", show: true, },
                { name: '课程管理', id: "kcgl", show: true, },
                { name: '团队管理', id: "tdgl", show: true, },
            ],
            dept: '',
            token: '',
            activeSlider: "enterprise-center",
            active: window.localStorage.getItem('TabActive') ? window.localStorage.getItem('TabActive') : 'home',
            user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {},
            courseRow: " "
        }
    },
    created() {

        var targetMode = this.$route.params.id;
        this.activeSlider = targetMode;

        // this.token = this.$route.params.token;
        this.token = localStorage.getItem('token');
        //取消学习报告显示权限
        // if (JSON.parse(localStorage.getItem('user'))) {
        //     var user = JSON.parse(localStorage.getItem('user'))


        //     if (user.role == 2) {
        //         this.tab[5].show = true
        //         console.log(user, 'user1111111111');
        //         // this.tab[2].show = true
        //     } else {
        //         this.tab[5].show = false
        //         console.log(user, 'user2222222222');
        //         //  this.tab[2].show = false
        //     }
        // }

        this.getTodept()
        this.GETexamStatus()
    },
    mounted() {

    },
    methods: {
        GETexamStatus() {
            examStatus({

            }, {
                Authorization: this.token,
            }).then(res => {
                if (res.code == 200) {
                    //     console.log(res.data, '11111111111111111')
                    if (res.data.status == 1) {

                        this.tab[2].show = true
                    } else {
                        window.localStorage.setItem('TabActive', 'home');
                        this.active = 'home'
                        this.tab[2].show = false
                    }
                }
            })
        },
        getTodept() {
            // this.token = this.$route.params.token
            // this.dept = this.$route.params.dept
            if (this.token)
                userCompanyInfo({}, { Authorization: this.token, }).then(res => {

                    if (res.code == 200) {

                        var data = res.data;
                        this.dept = data.deptId;
                        localStorage.setItem('dept', data.deptId)
                        localStorage.setItem('TopDeptId', data.topDeptId);

                    } else {
                        this.$message.error(res.msg)

                    }

                })
        },
        getUserType(id, token) {
            examAuth({}, {
                Authorization: token,
                TopDeptId: id
            }).then(res => {
                if (res.code == 200) {
                    // "role": 0, //用户角色(0:普通用户；1：管理员；2：超级管理员）
                    //     "assign": 1 //1=米诺测评已分配，0=米诺测评未被分配
                    window.localStorage.setItem('mnUserRole', res.data.role);
                    window.localStorage.setItem('mnUserAssign', res.data.assign);
                }
            }).catch(err => {
                // console.log(err);
            });
        },
        aa(row) {
            if (row.id == 'kcgl') {
                if (this.user && this.user.role == 2) {
                    return true
                } else {
                    return false
                }

            } else {
                return true
            }

        },
        setTab(row) {

            window.localStorage.setItem('TabActive', row.id);
            this.active = row.id
            // 异步执行记录检查（不阻塞路由跳转）
            var deptId = window.localStorage.getItem('TopDeptId');

            var token = window.localStorage.getItem('token');
            if (deptId && token) {


                checkLoginRecord()
                //.finally()
            }
        },
        getSlider(target) {
            if (target == 'study-report') {
                this.activeSlider = 'study-report-member';
            } else {
                this.activeSlider = target;
            }
        },
        handleBack() {
            this.activeSlider = 'enterprise-center';
        },
        getCourseStatus(params) {
            this.courseStatus = params;
        },
        getCourseRow(params) {
            this.courseRow = params;
        }
    }
}
</script>

<style scoped>
.page-container {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
}

.tabList-box {
    width: 100%;
    background: #fff;
}

.tabList {
    width: 1200px;
    height: 60px;
    margin: 0 auto;
    margin-top: 100px;

    display: flex;

}

.tabList>div {
    cursor: pointer;
    margin-left: 10px;
    width: auto;
    margin-right: 40px;
    height: 56px;
    font-weight: 600;
    font-size: 16px;
    line-height: 56px;
    color: #000;
}

.tabList>.active {

    border-bottom: 3px solid rgba(15, 108, 245, 1);
}

.content {
    width: 100%;
    /* min-height: 820px; */
    /* background: #fff; */
    margin: 0 auto;


}
</style>
